@if (isCustomView) {
  <custom-view [component]="customComponent" [customDataBinding]="customData">
  </custom-view>
}

@if (!isCustomView) {
  <standard-task [aggregate]="aggregate">
  </standard-task>
}